(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initHeaderAnimations = function () {
        var headers = document.querySelectorAll('[data-anim="header"]');

        if (!headers.length) {
            return;
        }

        function getDelay(header) {
            var delay = header.getAttribute('data-anim-delay');

            if (!delay) {
                return 0;
            }

            if (/ms$/i.test(delay)) {
                return parseFloat(delay) / 1000 || 0;
            }

            if (/s$/i.test(delay)) {
                return parseFloat(delay) || 0;
            }

            return parseFloat(delay) / 1000 || 0;
        }

        if (
            !window.gsap ||
            !window.ScrollTrigger ||
            !window.SplitText ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
            headers.forEach(function (header) {
                header.classList.add('is-inview');
            });
            return;
        }

        window.gsap.registerPlugin(window.ScrollTrigger, window.SplitText);

        headers.forEach(function (header) {
            if (header.dataset.animInitialized === 'true') {
                return;
            }

            header.dataset.animInitialized = 'true';

            var timeline = window.gsap.timeline({
                delay: getDelay(header),
            });
            var split = new window.SplitText(header, { type: 'lines' });

            split.lines.forEach(function (line) {
                window.gsap.set(line, {
                    position: 'relative',
                    display: 'block',
                    clipPath: 'inset(-0.2em 100% -0.2em 0)',
                    webkitClipPath: 'inset(-0.2em 100% -0.2em 0)',
                    willChange: 'clip-path',
                });
            });

            timeline.to(split.lines, {
                clipPath: 'inset(-0.2em 0% -0.2em 0)',
                webkitClipPath: 'inset(-0.2em 0% -0.2em 0)',
                duration: 2,
                stagger: {
                    amount: 0.15,
                },
                ease: 'power3.out',
                onComplete: function () {
                    window.gsap.set(split.lines, {
                        clearProps: 'clipPath,webkitClipPath,willChange',
                    });
                },
            });

            window.ScrollTrigger.create({
                trigger: header,
                animation: timeline,
                start: 'top bottom-=200px',
                end: 'center center',
            });
        });
    };
})();
